/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BalanceChangeSubjectType =
  typeof BalanceChangeSubjectType[keyof typeof BalanceChangeSubjectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BalanceChangeSubjectType = {
  DISTRIBUTION: 'DISTRIBUTION',
  ORDER: 'ORDER',
  PROCEEDS: 'PROCEEDS',
} as const;
